import React from 'react'
import { Layout } from 'antd'
import { connect } from 'react-redux'
import classNames from 'classnames'
import style from './style.module.scss'
import App from './App/index'

const mapStateToProps = ({ menu, settings: { isMobileMenuOpen }, apps, settings }) => ({
  menu,
  isMobileMenuOpen,
  apps,
  settings,
})

@connect(mapStateToProps)
class Menu extends React.Component {
  toggleMobileMenu = () => {
    const { dispatch, isMobileMenuOpen } = this.props
    dispatch({
      type: 'settings/CHANGE_SETTING',
      payload: {
        setting: 'isMobileMenuOpen',
        value: !isMobileMenuOpen,
      },
    })
  }

  render() {
    const {
      menu: { globalRouteMatch },
      isMobileMenuOpen,
      apps,
      settings,
      displayBanner,
    } = this.props
    const isApp = /^\/app(?=\/|$)/i.test(globalRouteMatch.path)
    const { appID } = globalRouteMatch.params
    // const IsAppClasses = isApp ? style.appMenuContainer : 'hidden-forever'
    const IsAppClasses = isApp ? style.appMenuContainer : 'hidden-forever'
    let IsAppClasses2 = isApp ? style.appMenuContainer2 : 'hidden-forever'
    if (displayBanner) {
      IsAppClasses2 = isApp
        ? classNames(style.appMenuContainer2, style.bannerVisible)
        : 'hidden-forever'
    }
    return (
      <div
        className={classNames(
          style.outer,
          {
            [style.outer__toggled]: isMobileMenuOpen,
          },
          // IsAppClasses,
          settings.isMobileView ? IsAppClasses : IsAppClasses2,
        )}
      >
        <Layout.Sider width="200" className={style.drawer}>
          {isApp && <App appID={appID} activeApp={apps.active} displayBanner={displayBanner} />}
          <a
            className={style.mobileToggleButton}
            role="button"
            tabIndex="-1"
            onKeyPress={this.toggleMobileMenu}
            onClick={this.toggleMobileMenu}
          >
            <span />
          </a>
        </Layout.Sider>
        <a
          className={style.backdrop}
          role="button"
          tabIndex="0"
          onKeyPress={this.toggleMobileMenu}
          onClick={this.toggleMobileMenu}
        />
      </div>
    )
  }
}

export default Menu
